export default function Bonus() {
  const bonus = [
    {
      icon: 'ri-chat-quote-line',
      title: 'Guia de Comunicação',
      description: 'Frases práticas para usar quando surgem situações difíceis.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Checklist de sinais',
      description: 'Lista simples para identificar rapidamente quando uma crise pode começar.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Mapa de crises',
      description: 'Ferramenta visual para entender padrões e evitar crises recorrentes.',
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-6xl mx-auto px-6">
        {/* Título */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Bônus Exclusivos
          </h2>
          <p className="text-lg text-gray-600">
            Materiais complementares para acelerar seus resultados
          </p>
        </div>

        {/* 3 Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {bonus.map((item, index) => (
            <div 
              key={index}
              className="bg-white border-2 border-teal-200 rounded-2xl p-8 space-y-4 hover:shadow-xl transition-all duration-300 relative overflow-hidden"
            >
              {/* Badge */}
              <div className="absolute top-4 right-4 bg-teal-600 text-white px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap">
                BÔNUS {index + 1}
              </div>

              {/* Ícone */}
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl">
                <i className={`${item.icon} text-teal-600 text-3xl`}></i>
              </div>

              {/* Título */}
              <h3 className="text-xl font-bold text-gray-900">
                {item.title}
              </h3>

              {/* Descrição */}
              <p className="text-gray-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Âncora de preço */}
        <div className="mt-14 bg-teal-700 rounded-2xl px-6 sm:px-8 py-10 text-center text-white">
          <p className="text-sm font-bold uppercase tracking-widest text-teal-300 mb-6">Valor total do que você leva</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-4 mb-8">
            <div className="text-center">
              <p className="text-base text-teal-200">Protocolo completo</p>
              <p className="text-2xl font-bold line-through text-teal-400">R$ 197,00</p>
            </div>
            <div className="text-2xl font-bold text-teal-400">+</div>
            <div className="text-center">
              <p className="text-base text-teal-200">3 bônus exclusivos</p>
              <p className="text-2xl font-bold line-through text-teal-400">R$ 251,00</p>
            </div>
            <div className="text-2xl font-bold text-teal-400">=</div>
            <div className="text-center">
              <p className="text-base text-teal-200">Valor real</p>
              <p className="text-2xl font-bold line-through text-teal-400">R$ 448,00</p>
            </div>
          </div>
          <div className="border-t border-teal-500 pt-6">
            <p className="text-teal-200 text-base mb-2">Você paga hoje apenas</p>
            <p className="text-5xl font-extrabold text-white mb-1">R$ 87,90</p>
            <p className="text-teal-300 text-sm">ou 12x de R$ 9,09 — com todos os bônus inclusos</p>
            <a
              href="https://pay.hotmart.com/U103348916W?checkoutMode=10"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full sm:w-auto sm:inline-block mt-6 bg-white text-teal-700 font-bold px-8 py-4 rounded-xl text-base sm:text-lg hover:bg-teal-50 transition-all duration-300 cursor-pointer text-center"
            >
              Quero acessar agora com todos os bônus
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}